import { render, staticRenderFns } from "./AddStudentReceipt.vue?vue&type=template&id=edb7a81e&scoped=true"
import script from "./AddStudentReceipt.vue?vue&type=script&lang=js"
export * from "./AddStudentReceipt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb7a81e",
  null
  
)

export default component.exports